export const UPDATE_ZONES = "UPDATE_ZONES";
export const UPDATE_VEHICLES = "UPDATE_VEHICLES";
export const UPDATE_LOCATIONS = "UPDATE_LOCATIONS";
export const UPDATE_TRIPS = "UPDATE_TRIPS";
export const UPDATE_SERVICES = "UPDATE_SERVICES";
export const UPDATE_TIMEZONE = "UPDATE_TIMEZONE";
